import { render, staticRenderFns } from "./addTemWaterAlartSetDialog.vue?vue&type=template&id=6d21bd46&scoped=true"
import script from "./addTemWaterAlartSetDialog.vue?vue&type=script&lang=js"
export * from "./addTemWaterAlartSetDialog.vue?vue&type=script&lang=js"
import style0 from "./addTemWaterAlartSetDialog.vue?vue&type=style&index=0&id=6d21bd46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d21bd46",
  null
  
)

export default component.exports